<template>
  <v-row>
    <v-col>
      <validation-observer ref="EmissionFormValidator">
        <v-form>
          <v-card>
            <v-card-title>{{ $route.params.id ? '排出事業者編集' : '排出事業者追加' }}</v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }"
                    :rules="{ required: (forms.subscriber_number), alpha_num_only: true, length: 7 }" name="加入者番号"
                    class="requiredMark">
                    <v-text-field v-model="forms.subscriber_number" :error-messages="errors" label="加入者番号"
                      hide-details="auto" persistent-placeholder required
                    >
                      <template v-slot:label>
                        <span>加入者番号</span>
                        <span class="ml-1">
                          ({{ forms.subscriber_number?.length || 0 }} / 7)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }"
                    :rules="{ required: (forms.edi_usage_key), numeric: true, length: 8 }" name="EDI利用確認キー"
                    class="requiredMark">
                    <v-text-field v-model="forms.edi_usage_key" :error-messages="errors" label="EDI利用確認キー"
                      hide-details="auto" persistent-placeholder required 
                    >
                      <template v-slot:label>
                        <span>EDI利用確認キー</span>
                        <span class="ml-1">
                          ({{ forms.edi_usage_key?.length || 0 }} / 8)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" rules="required|max:60" name="加入者名"
                    class="requiredMark">
                    <v-text-field v-model="forms.name" :error-messages="errors" label="加入者名"
                      hide-details="auto" persistent-placeholder required
                    >
                      <template v-slot:label>
                        <span>加入者名</span>
                        <span class="ml-1">
                          ({{ forms.name?.length || 0 }} / 60)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>

              <!-- 料金プラン -->
              <v-row>
                <v-col cols="4">
                  <v-select v-model="forms.jwnet_price_plan" :items="filteredJwnetPricePlans" label="JWNET料金プラン"
                    hide-details="auto" persistent-placeholder />
                </v-col>
              </v-row>
              <!-- /料金プラン -->

              <!-- C料金団体代表者の加入者番号 -->
              <v-row>
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" :rules="{ alpha_num_only: true, length: 8 }"
                    name="C料金団体代表者の加入者番号">
                    <v-text-field v-model="forms.parent_subscriber_number" :error-messages="errors"
                      label="C料金団体代表者の加入者番号" hide-details="auto" persistent-placeholder
                    >
                      <template v-slot:label>
                        <span>C料金団体代表者の加入者番号</span>
                        <span class="ml-1">
                          ({{ forms.parent_subscriber_number?.length || 0 }} / 8)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /C料金団体代表者の加入者番号 -->

              <!-- C料金団体代表者の加入者名 -->
              <v-row>
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" :rules="{ max: 12 }" name="C料金団体代表者の加入者名">
                    <v-text-field v-model="forms.parent_name" :error-messages="errors" label="C料金団体代表者の加入者名"
                      hide-details="auto" persistent-placeholder
                    >
                      <template v-slot:label>
                        <span>C料金団体代表者の加入者名</span>
                        <span class="ml-1">
                          ({{ forms.parent_name?.length || 0 }} / 12)
                        </span>
                      </template>
                      <template v-slot:counter></template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <!-- /C料金団体代表者の加入者名 -->

              <!-- 登録料請求先 -->
              <v-row>
                <v-col cols="4">
                  <v-select v-model="forms.registration_fee_type" :items="registration_fee_types" label="登録料請求先"
                    hide-details="auto" persistent-placeholder clearable />
                </v-col>
              </v-row>
              <!-- /登録料請求先 -->
            </v-card-text>
            <v-card-title>
              申請者
              <v-spacer />
              <v-btn small color="info" @click="addEmissionRequesterButtonClickEvent">
                申請者の追加
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-card flat>
                    <v-card-text>
                      <v-data-table :headers="tableHeaders" :items="dxeEmissionRequesters" :items-per-page="-1"
                        hide-default-footer disable-pagination disable-sort>
                        <template v-slot:[`item.emission_count`]="{ item }">
                          {{ item.emission_count }}件
                        </template>
                        <template v-slot:[`item.editable`]="{ item }">
                          <v-btn icon color="error" @click="emissionRequesterRemoveButtonClickEvent(item)">
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="registerButtonClickEvent">
                登録
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </validation-observer>
      <confirm ref="confirm" />
      <emission-requester-dialog :enable-dialog="enableEmissionRequesterDialog"
        @closeEvent="emissionRequesterDialogCloseCallback" @registerEvent="emissionRequesterDialogRegisterCallback" />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import EmissionRequesterDialog from './dialogs/_Requester'
import Confirm from '../../../../components/Confirm'

export default {
  name: 'EmissionForm',
  components: {
    EmissionRequesterDialog,
    Confirm
  },
  mixins: [],
  props: {},
  data() {
    return {
      enableEmissionRequesterDialog: false,
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'tenant_name', text: '加入者名' },
        { value: 'emission_count', text: 'EDI利用数' },
        { value: 'editable', text: '削除', align: 'end' },
      ],
      dxeEmissionRequesters: [],
      forms: {
        id: null,
        subscriber_number: null,
        edi_usage_key: null,
        name: null,
        jwnet_price_plan: null,
        parent_subscriber_number: null,
        parent_name: null,
        registration_fee_type: null,
        dxe_emission_requesters: []
      },
      jwnet_price_plans: [],
      registration_fee_types: [],
    }
  },
  computed: {
    /**
     * JWNET料金プランの登録
     * 新規登録時は'解約(C料金(DEX))'を除外する
     */
    filteredJwnetPricePlans() {
      if (!this.$route.params.id) {
        return this.jwnet_price_plans.filter( plan => plan.value !== 'canceled_c_plan_dxe')
      }
      return this.jwnet_price_plans
    }
  },
  watch: {},
  created() {
    if (this.$route.params.id) {
      this.editAdminEmission({ id: this.$route.params.id }).then((content) => {
        this.forms = content
        this.jwnet_price_plans = content.jwnet_price_plans
        this.registration_fee_types = content.registration_fee_types
        this.remakeDisplayList()
      })
    } else {
      this.newAdminEmission().then((content) => {
        this.forms = content
        this.jwnet_price_plans = content.jwnet_price_plans
        this.registration_fee_types = content.registration_fee_types
        this.remakeDisplayList()
      })
    }
  },
  methods: {
    ...mapActions('AdminMasterEmission', {
      newAdminEmission: 'new',
      editAdminEmission: 'edit',
      createAdminEmission: 'create',
      updateAdminEmission: 'update',
      warningCheckAdminEmission: 'warningCheck'
    }),
    ...mapActions('snackbar', {showError: 'showError'}),
    addEmissionRequesterButtonClickEvent() {
      this.enableEmissionRequesterDialog = true
    },
    emissionRequesterRemoveButtonClickEvent(item) {
      item._destroy = true
      this.remakeDisplayList()
    },
    emissionRequesterDialogCloseCallback() {
      this.enableEmissionRequesterDialog = false
    },
    emissionRequesterDialogRegisterCallback(forms) {

      let push_flg = true
      let exit_flg = true
      for (const requester of this.forms.dxe_emission_requesters) {
        if (requester.subscriber_number == forms.subscriber_number) {
          push_flg = false
          if (requester._destroy) {
            requester._destroy = false
          } else {
            this.showError({ message: '既に同じ加入者番号の申請者が存在します' })
            exit_flg = false
          }
        }
      }

      if (push_flg) {
        this.forms.dxe_emission_requesters.push(forms)
      }
      if (exit_flg) {
        this.remakeDisplayList()
        this.emissionRequesterDialogCloseCallback()
      }

    },
    registerButtonClickEvent() {
      this.$refs.EmissionFormValidator.validate().then((result) => {
        if (!result) return
        this.sendRegistrationInformation()
      })
    },
    sendRegistrationInformation() {
      let params = {
        subscriber_number: this.forms.subscriber_number,
        edi_usage_key: this.forms.edi_usage_key,
        name: this.forms.name,
        jwnet_price_plan: this.forms.jwnet_price_plan,
        parent_subscriber_number: this.forms.parent_subscriber_number,
        parent_name: this.forms.parent_name,
        registration_fee_type: this.forms.registration_fee_type,
        dxe_emission_requesters_attributes: this.forms.dxe_emission_requesters
      }

      if (this.$route.params.id) {
        if (this.forms.jwnet_price_plan === 'canceled_c_plan_dxe') {
          // C料金(DXE)解約の場合はwarning_checkで判定
          this.warningCheckAdminEmission({ id: this.$route.params.id }).then((warning) => {
            // warning_checkがtrueの場合は警告ダイアログを表示
            if (warning) {
              this.$refs.confirm.showCancelPricePlanConfirm().then((confirm) => {
                if (confirm) {
                  this.updateAdminEmission({ id: this.$route.params.id, params }).then(() => {
                    this.$router.push({ name: 'AdminMasterEmissions' })
                  })
                }
              })
            } else {
              // warning_checkがfalseの場合は警告メッセージなしで登録する
              this.updateAdminEmission({ id: this.$route.params.id, params }).then(() => {
                this.$router.push({ name: 'AdminMasterEmissions' })
              })
            }
          })
        } else {
          this.updateAdminEmission({ id: this.$route.params.id, params }).then(() => {
            this.$router.push({ name: 'AdminMasterEmissions' })
          })
        }
      } else {
        this.createAdminEmission({ params: params }).then(() => {
          this.$router.push({ name: 'AdminMasterEmissions', params: { resetPagination: true } })
        })
      }
    },
    remakeDisplayList() {
      this.dxeEmissionRequesters = []
      for (const requester of this.forms.dxe_emission_requesters) {
        if (!requester._destroy) {
          this.dxeEmissionRequesters.push(requester)
        }
      }
    }
  }
}
</script>
